module.exports = __webpack_public_path__ + "img/logoariasmall.286f336d.png";